module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921012651_T.42b2d93a.jpg";